import React from 'react'

import {
  Box,
  Text,
  AspectRatio,
  GatsbyImage,
  GatsbyImageContainer,
  Link,
} from 'system'

export const Physician = ({
  path,
  name,
  imageFluid,
  specialties,
  phoneNumber,
  size = 'small',
  ...props
}) => (
  <Box {...props}>
    <Link to={`/our-team/${path}/`}>
      {imageFluid && (
        <GatsbyImageContainer
          borderRadius="50%"
          maxWidth={['12rem', size === 'large' ? '18rem' : '12rem']}
          mb={size === 'large' ? [2, 3] : [1, 2]}
          mx="auto"
          overflow="hidden"
          width="100%"
        >
          <AspectRatio x={1} y={1}>
            <GatsbyImage fluid={imageFluid} alt={name} critical={true} />
          </AspectRatio>
        </GatsbyImageContainer>
      )}
      {name && (
        <Text
          boxStyle="lastNoMargin"
          fontFamily="sansCond"
          fontSize={
            size === 'large'
              ? ['midLarge', null, 'large']
              : ['medium', 'midLarge']
          }
          lineHeight="title"
          mb={1}
          textAlign="center"
          textStyle="caps"
        >
          {name}
        </Text>
      )}
      {specialties && (
        <Text
          boxStyle="lastNoMargin"
          color="sandDark"
          lineHeight="copy"
          mb={1}
          textAlign="center"
        >
          {specialties}
        </Text>
      )}
      {phoneNumber && (
        <Text
          fontSize="small"
          fontWeight="bold"
          lineHeight="copy"
          textAlign="center"
        >
          {phoneNumber}
        </Text>
      )}
    </Link>
  </Box>
)
